import { Box, Accordion, AccordionSummary, Breadcrumbs } from "@mui/material";
import { useEffect, useState } from "react";
import "Styles/MedicalRecords.css";
import cloneDeep from "lodash/cloneDeep";
import Medicalhistories1 from "assets/images/MedicalHistories.png";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import NoHealthRecords from "components/UI/NoHealthRecords";
import HealthRecordHeader from "components/HealthRecord/HealthRecordHeader";
import { KMedicalRecordType } from "utilities/constants";
import { useGetMedicalHistoriesQuery } from "api/MedicalRecordApi";
import useAuth from "hooks/useAuth";
import { stringify } from "qs";
import DefaultLoader from "components/UI/DefaultLoader";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { NavigateNext } from "@mui/icons-material";
import { BCPatientMedicalHistories } from "components/UI/BreadcrumbsList";
import CPagination from "components/UI/CPagination";

const groupBy = [
  { name: "None", value: "none", label: "None" },
  { name: "History", value: "code", label: "History" },
];

const MedicalHistory = () => {
  const { accessToken } = useAuth();

  const [groupedBy, setGroupedBy] = useState("none");
  const [groupbyCurrentPage, setGroupByCurrentPage] = useState(1);
  const [page, setPage] = useState(1);
  const [groupByTitle, setGroupbyTitle] = useState(null);
  const [perPage, setPerPage] = useState(10);
  const [groupTitle, setGroupTitle] = useState([]);
  const [code, setCode] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [hcps, setHcps] = useState([]);
  const [encounters, setEncounters] = useState([]);
  const countPerPage = 10;
  const [mostRecentDataChecked, setMostRecentDataChecked] = useState(false);
  const [categories, setCategories] = useState([]);
  const [expanded, setExpanded] = useState(false);

  const [groupbycollection, setGroupbyCollection] = useState(
    cloneDeep([].slice(0, countPerPage))
  );
  const {
    data: medicalHistory,
    isLoading: loading,
    isFetching,
  } = useGetMedicalHistoriesQuery(
    {
      accessToken,
      page,
      perPage,
      query: `&${stringify({
        group_by: groupedBy === "none" ? undefined : groupedBy,
        code: code.length === 0 ? undefined : code.join(","),
        from_date:
          fromDate === null
            ? undefined
            : new Intl.DateTimeFormat("en-US").format(fromDate),
        to_date:
          toDate === null
            ? undefined
            : new Intl.DateTimeFormat("en-US").format(toDate),
        healthcare_provider_ids: hcps.length === 0 ? undefined : hcps.join(","),
        encounter: encounters.length === 0 ? undefined : encounters.join(","),
        category: categories.length === 0 ? undefined : categories.join(","),
      })}`,
    },
    { refetchOnMountOrArgChange: true, refetchOnReconnect: true }
  );

  useEffect(() => {
    setExpanded(false);
  }, [groupedBy]);

  useEffect(() => {
    if (!Array.isArray(medicalHistory?.medical_histories)) {
      setGroupTitle(Object.keys(medicalHistory?.medical_histories || []));
    }
  }, [medicalHistory]);

  const handleGroupBy = (e) => {
    setGroupedBy(e.value);
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
    setGroupByCurrentPage(1);
  };

  const groupbyUpdatePage = (p) => {
    setGroupByCurrentPage(p);
    const to = countPerPage * p;
    const from = to - countPerPage;
    setGroupbyCollection(
      cloneDeep(
        medicalHistory?.medical_histories[groupByTitle]?.slice(from, to)
      )
    );
  };

  return (
    <Box sx={{ fontFamily: "Open Sans" }}>
      <Breadcrumbs
        separator={<NavigateNext fontSize="small" />}
        aria-label="breadcrumb"
      >
        {BCPatientMedicalHistories}
      </Breadcrumbs>
      <Box>
        <Box>
          <HealthRecordHeader
            groupBy={groupBy}
            handleGroupBy={handleGroupBy}
            icon={Medicalhistories1}
            medicalRecordType={medicalHistory}
            title={KMedicalRecordType.MEDICAL_HISTORIES}
            setCode={setCode}
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
            code={code}
            mostRecentDataChecked={mostRecentDataChecked}
            setMostRecentDataChecked={setMostRecentDataChecked}
            hcps={hcps}
            setHcps={setHcps}
            encounters={encounters}
            setEncounters={setEncounters}
            categories={categories}
            setCategories={setCategories}
          />
        </Box>

        {loading || isFetching ? (
          <DefaultLoader />
        ) : medicalHistory?.medical_histories?.length !== 0 ? (
          <Box sx={{ mt: "1rem" }}>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "10.625rem 1fr 2fr",
                gap: "1rem",
                px: "1rem",
                py: ".25rem",
                mb: "0.625rem",
                fontSize: "1rem",
                color: "#8e8e8e",
              }}
            >
              <Box>Recorded date</Box>
              <Box>Provider</Box>
              <Box>History</Box>
            </Box>
            {!Array.isArray(medicalHistory.medical_histories) ? (
              groupTitle?.length !== 0 ? (
                groupTitle?.map((title, index) => (
                  <Accordion
                    key={title}
                    elevation={0}
                    expanded={expanded === `panel${index + 1}`}
                    onChange={handleAccordionChange(`panel${index + 1}`)}
                    disableGutters={true}
                    sx={{
                      borderTop: "1px solid rgb(0,0,0,0.125)",
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon color="primary" />}
                      aria-controls={`panel${index + 1}a-content`}
                      id={`panel${index + 1}a-header`}
                      onClick={() => {
                        setGroupbyCollection(
                          cloneDeep(
                            medicalHistory.medical_histories[title]?.slice(
                              0,
                              10
                            )
                          )
                        );
                        setGroupbyTitle(title);
                      }}
                      sx={{ color: "primary.main", bgcolor: "#dcf0ff" }}
                    >
                      {title +
                        " (" +
                        medicalHistory.medical_histories[title]?.length +
                        ")"}
                    </AccordionSummary>
                    <Box sx={{ mt: ".25rem", display: "grid", gap: ".25rem" }}>
                      {groupbycollection?.map((item) => (
                        <RecordCard key={item?.id} item={item} />
                      ))}
                      <Pagination
                        pageSize={10}
                        onChange={(p) => {
                          groupbyUpdatePage(p);
                        }}
                        className="align-pagination mt-3 mb-3"
                        current={groupbyCurrentPage}
                        total={medicalHistory?.medical_histories[title]?.length}
                        showTitle={false}
                      />
                    </Box>
                  </Accordion>
                ))
              ) : (
                <NoHealthRecords />
              )
            ) : (
              <Box
                sx={{ display: "grid", gap: "0.625rem", fontSize: "0.875rem" }}
              >
                {medicalHistory?.medical_histories?.map((item) => (
                  <RecordCard key={item?.id} item={item} />
                ))}
              </Box>
            )}
            {groupedBy === "none" && (
              <CPagination
                page={page}
                perPage={perPage}
                setPage={setPage}
                setPerPage={setPerPage}
                totalCount={medicalHistory?.total_records}
              />
            )}
          </Box>
        ) : (
          <NoHealthRecords />
        )}
      </Box>
    </Box>
  );
};

export default MedicalHistory;

const RecordCard = ({ item }) => {
  return (
    <Box
      sx={{
        p: "1rem",
        borderRadius: "5px",
        bgcolor: "#f8f8f8",
        display: "grid",
        gridTemplateColumns: "10.625rem 1fr 2fr",
        gap: "1rem",
        "& > div": {
          whiteSpace: "nowrap",
          width: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      }}
    >
      <Box component={"div"} title={item?.onset_period?.start}>
        {item?.onset_period?.start}
      </Box>
      <Box component={"div"} title={item?.heathcare_provider_name}>
        {item?.heathcare_provider_name}
      </Box>
      <Box component={"div"} title={item?.code}>
        {item?.code}
      </Box>
    </Box>
  );
};
